import { IconButton, Modal, Tooltip } from "@mui/material";
import { DataGrid, GridColumns, GridSelectionModel } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import React, { useEffect, useState, useContext } from "react";
// import { Data } from "react-csv/components/CommonPropTypes";
import EstoqueParceiro from "../../components/classes/EstoqueParceiro";
import EstoqueParceiroDataset from "../../components/data/EstoqueParceiroDataset";
import SkuHelper from "../../helper/skuHelper";
import CentroDataset from "../../components/data/CentroDataset";
import Centro from "../../components/classes/CentroDistribuicao";
import { confirmAlert } from "react-confirm-alert";
import PageHelper from "../../helper/pageHelper";
import { hasInCache } from "../../helper/cacheHelper";
import Parceiro from "../../components/classes/Parceiro";
import CustomToolbarEstoqueParceiro from "./customToolbar";
import PropriedadeParceiroDataset from "../../components/data/PropriedadeParceiroDataSet";
import { UserContext } from "../../App";
import { Download } from "@mui/icons-material";
import DownloadCSVModal from "../../components/common/DownloadCSVModal/DownloadCSVModal";
import Utils from "../../helper/utils";

import styles from './detail.module.css';

import { useTranslation } from "react-i18next";

type Data = Array<Record<string, any>>;

export default function EstoqueParceiroGrid(
  props: EstoqueParceiroGridPropsTypes
) {
  const { t } = useTranslation();

  const user: any = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(50);
  const [estoqueParceiro, setEstoqueParceiro] = React.useState<
    EstoqueParceiro[]
  >([]);
  const [centros, setCentros] = React.useState<Centro[]>([]);
  const [rows, setRows] = useState<Data>([]);
  const columns: GridColumns = createColumns();

  const [openDownloadCSVModal, setOpenDownloadCSVModal] =
    useState<boolean>(false);

  const estoqueParceiroDataset: EstoqueParceiroDataset =
    new EstoqueParceiroDataset();
  const centroDataset: CentroDataset = new CentroDataset();
  const propriedadeParceiroDataset: PropriedadeParceiroDataset =
    new PropriedadeParceiroDataset();

  async function fetchData() {
    let centroIndustrializacao =
      await propriedadeParceiroDataset.getCentroIndustrializacao(
        props.parceiro.codigoFornecedorSAP.valueOf()
      );
    if (centroIndustrializacao == "N/A") {
      Mensagem(
        t("common.error"),
        t("pages.stockPartnerNamed.text.unableToFindIndustrializationCenter"),
        () => { } //to prevent infinite loop
      );
      setLoading(false);
    } else {
      estoqueParceiroDataset
        .getAll(centroIndustrializacao)
        .then((data) => {
          if (data) {
            setEstoqueParceiro(data);
            centroDataset.ListarAtivos().then((centros) => {
              setCentros(centros);
            });
          }
        })
        .catch(console.error)
        .finally(() => { setLoading(false); });
    }
  }

  useEffect(() => {
    if (hasInCache("CodigoFornecedorSAPSelecionado")) {
      fetchData();
    } else {
      Mensagem(t("common.warning"), t("pages.stockPartnerNamed.text.selectPartner"));
    }
  }, []);

  useEffect(() => {
    fillTable(estoqueParceiro);
  }, [centros]);

  function Mensagem(titulo: string, mensagem: string, onClick = () => { PageHelper.refreshPage(); }): void {
    return confirmAlert({
      title: titulo,
      message: mensagem,
      buttons: [
        {
          label: t("common.ok"),
          onClick,
        },
      ],
    });
  }

  function getCentroDescricao(idCentro: string): string {
    let nome: string = "";
    if (centros.length > 1) {
      if (centros.length > 1) {
        let centroEncotrado = centros.filter(
          (centro) => centro.centro.toString() == idCentro
        )[0];
        if (centroEncotrado) {
          nome = centroEncotrado.nome.toString();
        }
      }
    }
    return nome;
  }

  function createColumns(): GridColumns {
    let cols: GridColumns = [
      {
        field: "id",
        headerName: t("common.id"),
        width: 80,
        align: "center",
        headerAlign: "center",
        renderHeader: (item) => {
          return <div>#</div>;
        },
      },
      {
        field: "material",
        headerName: t("common.material"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "materialDesc",
        headerName: t("common.materialDescription"),
        type: "string",
        width: 420,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centro",
        headerName: t("common.center"),
        type: "string",
        width: 110,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "centroDesc",
        headerName: t("common.centerDescription"),
        type: "string",
        width: 420,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "quantidade",
        headerName: t("common.quantity"),
        type: "string",
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "opcoes",
        headerName: t("common.otpions"),
        type: "number",
        width: 150,
        editable: false,
        align: "center",
        headerAlign: "center",
        renderCell: (gridItem) => {
          return (
            <div>
              <Tooltip title={t("common.edit")}>
                <span>
                  <IconButton
                    disabled={user.isSuporte}
                    onClick={() => handleUpdateEstoqueParceiro(gridItem)}
                  >
                    <EditIcon />
                  </IconButton>
                </span>
              </Tooltip>
              {/* <Tooltip title="Apagar">
              <span>
                <IconButton onClick={() => handleDeleteEstoque(gridItem)} disabled={user.isSuporte}>
                  <DeleteIcon />
                </IconButton>
                </span>
              </Tooltip> */}
            </div>
          );
        },
      },
    ];
    return cols;
  }

  function handleUpdateEstoqueParceiro(item: any) {
    item.row.quantidade = parseFloat(
      item.row.quantidade
        .replace(item.row.unidadeMedida, "")
        .replaceAll(".", "")
        .replace(",", ".")
    );
    props.setSelectedEstoqueParceiroupdater(item.row);
    props.handleUpdateEstoqueParceiro();
  }

  function handleDeleteEstoque(item: any) {
    item.row.quantidade = item.row.quantidade.slice(
      0,
      item.row.unidadeMedida.length * -1
    );
    estoqueParceiroDataset
      .remove(item.row)
      .then(() => {
        fetchData();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function fillTable(estoqueEmbalagens: EstoqueParceiro[]) {
    let gridData: Data = [];
    estoqueEmbalagens.forEach((item: EstoqueParceiro) => {
      let estoque = JSON.parse(EstoqueParceiro.toJson(item));
      estoque.materialDesc = SkuHelper.getSKUName(parseInt(item.material));
      estoque.centroDesc = getCentroDescricao(item.centro);

      estoque.quantidade = Utils.maskNumberToSAPDecimalVisualization(
        parseFloat(estoque.quantidade).toFixed(3),
        estoque.unidadeMedida
      );

      gridData.push(estoque);
    });
    setRows(gridData);
  }

  const handleClickOpenDownloadCSV = () => {
    setOpenDownloadCSVModal(true);
  };

  function handleCloseDownloadCSVModal() {
    setOpenDownloadCSVModal(false);
  }

  return (
    <div className={`divFlow ${styles.table}`}>
      <div className="containerToolbar">
        <Tooltip title={t("pages.stockPartnerNamed.text.csvDownload")}>
          <span>
            <IconButton
              onClick={handleClickOpenDownloadCSV}
              disabled={loading || user.isSuporte}
            >
              <Download />
            </IconButton>
          </span>
        </Tooltip>
      </div>
      <div className={styles.table}>
        <DataGrid
          loading={loading}
          rows={rows}
          columns={columns}
          rowsPerPageOptions={[50, 100, 250, 500]}
        />
      </div>
      <Modal
        open={openDownloadCSVModal}
        onClose={handleCloseDownloadCSVModal}
        sx={{
          display: "flex",
          "justify-content": "center",
          "align-items": "center",
        }}
      >
        <DownloadCSVModal
          handleClose={handleCloseDownloadCSVModal}
          rows={rows}
          columns={columns.filter((item) => item.field != "opcoes")}
          name={`${t("pages.stockPartnerNamed.text.partner")} ${props.parceiro?.nome}`}
        />
      </Modal>
    </div>
  );
}

interface EstoqueParceiroGridPropsTypes {
  parceiro: Parceiro;
  centro: string;
  setSelectedEstoqueParceiroupdater: any;
  handleUpdateEstoqueParceiro: any;
}
